<template>
  <div id="order-product-list">
    <template>
      <div class="mt-4 _fs-20">
        เลือกจำนวนเดือนที่คุณต้องการ
      </div>
      <v-divider class="my-4"></v-divider>
      <order-oa-chat-month-product
        :disabled="disabled"
        :oa-chat-month="oaChatMonth"
        :products="products"
        @update:oa-chat-month="updateSync('oa-chat-month', $event)"
      >
      </order-oa-chat-month-product>
    </template>

    <template v-if="oaChatMonth">
      <div class="mt-4 _fs-20">
        เลือกวันที่ต้องการเปิดใช้งานแพ็กเกจ
      </div>
      <v-divider class="my-4"></v-divider>
      <base-card>
        <v-row>
          <v-col
            cols="12"
            md="6">
            <base-date-picker
              :disabled="disabled"
              :value="oaChatStartedAt"
              :min="minDate"
              :max="maxDate"
              label="วันที่เปิดใช้งานแพ็กเกจ"
              hide-details
              @input="updateSync('oa-chat-started-at', $event)"
            >
            </base-date-picker>
          </v-col>
          <v-col
            cols="12"
            md="6">
            <base-date-picker
              disabled
              :value="oaChatExpired"
              label="วันที่แพ็กเกจหมดอายุ"
              hide-details
              input-class="_green--text"
            >
            </base-date-picker>
          </v-col>
          <v-col
            cols="12">
            <div class="mt-4 error--text _fs-14">
              <div>หมายเหตุ</div>
              <div>
                * กรณีแจ้งวันเริ่มใช้งานเป็น วันหยุด หรือวันนักขัตฤกษ์
                ระบบจะดำเนินการเปิดให้บริการในวันทำการถัดไป
              </div>
              <div>
                * สำหรับลูกค้าที่ย้ายมาจาก Agency อื่น หากมีแพ็กเกจอยู่แล้ว
                จะสามารถเริ่มใช้งานได้ในเดือนถัดไป
              </div>
              <div>
                * แพ็กเกจสามารถเริ่มวันใดของเดือนก็ได้แต่แนะนำให้เริ่มในวันที่ 1 เพราะ LINE
                Thailand จะมีการตัดวันใช้งานในวันสิ้นเดือนเสมอ (เช่นเริ่มในวันที่ 16 มีนาคม
                อายุการใช้งานของเดือนแรกจะใช้ได้ตั้งแต่วันที่ 16-31 มีนาคม)
              </div>
            </div>
          </v-col>
        </v-row>
      </base-card>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'OrderOaChatProductList',
  components: {
    BaseCard: () => import('@/components/BaseCard.vue'),
    BaseDatePicker: () => import('@/components/BaseDatePicker.vue'),
    OrderOaChatMonthProduct: () => import('@/components/OrderOaChatMonthProduct.vue')
  },
  props: {
    products: {
      type: Array,
      default: () => []
    },
    oaChatMonth: {
      type: Number,
      default: 0
    },
    oaChatStartedAt: {
      type: [Date, String],
      default: ''
    },
    minOaChatStartedAt: {
      type: Date,
      default: undefined
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      maxDate: '',
      minDate: ''
    }
  },
  computed: {
    ...mapGetters({
      MAXIMUM_PERIOD_PRE_ORDER: 'SystemConfig/GET_MAXIMUM_PERIOD_PRE_ORDER'
    }),
    oaChatExpired() {
      return this.$utils.createDayjsDate(this.oaChatStartedAt)
        .add((this.oaChatMonth - 1), 'month')
        .endOf('month')
        .toDate()
    }
  },
  mounted() {
    this.minDate = this.$utils.createDayjsDate(this.minOaChatStartedAt)
      .toDate()
    this.maxDate = this.$utils.createDayjsDate(this.minOaChatStartedAt)
      .add(this.MAXIMUM_PERIOD_PRE_ORDER.value, this.MAXIMUM_PERIOD_PRE_ORDER.unit)
      .toDate()
  },
  methods: {
    updateSync(field, value) {
      this.$emit(`update:${field}`, value)
    }
  }
}
</script>
